import { api } from '../utils/axios';

export function setEgressProviderPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_EGRESS_PROVIDER_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export const getEgressProviders = (userData) => async (dispatch) => {
    let data = {};
    data.target_egress_provider = userData ? userData : {}
    dispatch({
        type: "GET_EGRESS_PROVIDER_REQUESTED"
    });

    try {
        const response = await api.post('admin/get_egress_providers', data);
        dispatch({
            type: "GET_EGRESS_PROVIDER_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "GET_EGRESS_PROVIDER_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }
}

export const deleteEgressProvider = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_provider = userData

    dispatch({
        type: "DELETE_EGRESS_PROVIDER_REQUESTED"
    })

    try {
        const response = await api.post('admin/delete_egress_provider', data);
        dispatch({
            type: "DELETE_EGRESS_PROVIDER_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "DELETE_EGRESS_PROVIDER_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const updateEgressProvider = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_provider = userData

    dispatch({
        type: "UPDATE_EGRESS_PROVIDER_REQUESTED"
    })

    try {
        const response = await api.post('admin/update_egress_provider', data);
        dispatch({
            type: "UPDATE_EGRESS_PROVIDER_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "UPDATE_EGRESS_PROVIDER_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const createEgressProvider = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_provider = userData

    dispatch({
        type: "CREATE_EGRESS_PROVIDER_REQUESTED"
    })

    try {
        const response = await api.post('admin/create_egress_provider', data);
        dispatch({
            type: "CREATE_EGRESS_PROVIDER_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "CREATE_EGRESS_PROVIDER_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}


export const getEgressGateways = (userData) => async (dispatch) => {
    let data = {}
    data.target_egress_gateway = userData ? userData : {}
    dispatch({
        type: "GET_EGRESS_GATEWAY_REQUESTED"
    });

    try {
        const response = await api.post('admin/get_egress_gateways', data);
        dispatch({
            type: "GET_EGRESS_GATEWAY_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "GET_EGRESS_GATEWAY_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }
}

export const deleteEgressGateway = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_gateway = userData

    dispatch({
        type: "DELETE_EGRESS_GATEWAY_REQUESTED"
    })

    try {
        const response = await api.post('admin/delete_egress_gateway', data);
        dispatch({
            type: "DELETE_EGRESS_GATEWAY_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "DELETE_EGRESS_GATEWAY_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const updateEgressGateway = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_gateway = userData

    dispatch({
        type: "UPDATE_EGRESS_GATEWAY_REQUESTED"
    })

    try {
        const response = await api.post('admin/update_egress_gateway', data);
        dispatch({
            type: "UPDATE_EGRESS_GATEWAY_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "UPDATE_EGRESS_GATEWAY_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const createEgressGateway = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_gateway = userData

    dispatch({
        type: "CREATE_EGRESS_GATEWAY_REQUESTED"
    })

    try {
        const response = await api.post('admin/create_egress_gateway', data);
        dispatch({
            type: "CREATE_EGRESS_GATEWAY_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "CREATE_EGRESS_GATEWAY_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const getEgressCredentials = (userData) => async (dispatch) => {
    let data = {};
    data.target_egress_credential = {}
    data.target_egress_credential[userData.type] = userData.id
    dispatch({
        type: "GET_EGRESS_CREDENTIAL_REQUESTED"
    });

    try {
        const response = await api.post('admin/get_egress_credentials', data);
        dispatch({
            type: "GET_EGRESS_CREDENTIAL_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "GET_EGRESS_CREDENTIAL_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }
}

export const deleteEgressCredential = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_credential = userData

    dispatch({
        type: "DELETE_EGRESS_CREDENTIAL_REQUESTED"
    })

    try {
        const response = await api.post('admin/delete_egress_credential', data);
        dispatch({
            type: "DELETE_EGRESS_CREDENTIAL_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "DELETE_EGRESS_CREDENTIAL_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const updateEgressCredential = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_credential = userData

    dispatch({
        type: "UPDATE_EGRESS_CREDENTIAL_REQUESTED"
    })

    try {
        const response = await api.post('admin/update_egress_credential', data);
        dispatch({
            type: "UPDATE_EGRESS_CREDENTIAL_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "UPDATE_EGRESS_CREDENTIAL_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const createEgressCredential = (userData) => async (dispatch) => {

    let data = {}
    data.target_egress_credential = userData

    dispatch({
        type: "CREATE_EGRESS_CREDENTIAL_REQUESTED"
    })

    try {
        const response = await api.post('admin/create_egress_credential', data);
        dispatch({
            type: "CREATE_EGRESS_CREDENTIAL_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "CREATE_EGRESS_CREDENTIAL_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }

}

export const getEgressProviderMappings = (userData) => async (dispatch) => {
    let data = {};
    data.target_egress_provider_mapping = {}
    data.target_egress_provider_mapping[userData.type] = userData.id
    
    dispatch({
        type: "GET_EGRESS_MAPPINGS_REQUESTED"
    });

    try {
        const response = await api.post('admin/get_egress_provider_mappings', data);
        dispatch({
            type: "GET_EGRESS_MAPPINGS_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "GET_EGRESS_MAPPINGS_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

    }
}

export const createEgressProviderMapping = (userData) => async (dispatch) => {
    let data = {};
    data.target_egress_provider_mapping = {
        ...userData.data
    }
    data.target_egress_provider_mapping[userData.type] = userData.id
    
    dispatch({
        type: "CREATE_EGRESS_MAPPING_REQUESTED"
    });

    try {
        if (userData.data.username) {
            const { egress_provider_id, username, password } = userData.data
            let details = {
                egress_provider_id,
                enabled: true,
                username,
                password
            }
            details[userData.type] = userData.id
            try {
                const credResponse = await dispatch(createEgressCredential(details))
                const { egress_credential_id } = credResponse.response.egress_credential
                userData.data.egress_credential_id = egress_credential_id
            } catch (e) {
                const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
                throw new Error(errorMsg);
            }
        }

        const response = await api.post('admin/create_egress_provider_mapping', data);
        dispatch({
            type: "CREATE_EGRESS_MAPPING_SUCCESS",
            response: response
        });
        return {response}
    } catch (e) {
        dispatch({
            type: "CREATE_EGRESS_MAPPING_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        throw new Error(errorMsg);

    }
}
export const updateEgressProviderMapping = (userData) => async (dispatch) => {
    let data = {};
    data.target_egress_provider_mapping = {
        ...userData.data
    }
    data.target_egress_provider_mapping[userData.type] = userData.id

    dispatch({
        type: "CREATE_EGRESS_MAPPING_REQUESTED"
    });

    try {
        const response = await api.post('admin/update_egress_provider_mapping', data);
        dispatch({
            type: "CREATE_EGRESS_MAPPING_SUCCESS",
            response: response
        });
        return { response }
    } catch (e) {
        dispatch({
            type: "CREATE_EGRESS_MAPPING_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        throw new Error(errorMsg);

    }
}
export const deleteEgressProviderMapping = (userData) => async (dispatch) => {
    let data = {};
    data.target_egress_provider_mapping = {
        ...userData
    }
    dispatch({
        type: "CREATE_EGRESS_MAPPING_REQUESTED"
    });

    try {
        const response = await api.post('admin/delete_egress_provider_mapping', data);
        dispatch({
            type: "CREATE_EGRESS_MAPPING_SUCCESS",
            response: response
        });
        return { response }
    } catch (e) {
        dispatch({
            type: "CREATE_EGRESS_MAPPING_FAILED",
            error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        });
        const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
        throw new Error(errorMsg);

    }
}



export const setCurrentProvider = (userData) => async (dispatch) => {
    dispatch({
        type: "SET_CURRENT_EGRESS_PROVIDER",
        response: userData
    })
}